import {story as river} from './stories/river/data';
import {story as sensations} from './stories/sensations/data';
import {story as crumple} from './stories/crumple/data';
import {story as melt} from './stories/melt/data';
import {story as snake} from './stories/snake/data';
import {story as drift} from './stories/drift/data';


const data = [
	river,
	sensations,
	crumple,
	//tremor,
	//tangle,
	melt,
	//radio,
	snake,
	drift,
	//smoke,
	//gum,
];

export default data;
